import moment from 'moment';

/** 展示用：仅返回四位年份 */
export function formatGraduationYear(val) {
    if (val == null || val === '') {
        return '';
    }
    if (Array.isArray(val)) {
        return val.length ? String(val[0]) : '';
    }
    const str = String(val).trim();
    if (/^\d{4}$/.test(str)) {
        return str;
    }
    const parsed = moment(str);
    if (parsed.isValid()) {
        return parsed.format('YYYY');
    }
    return str.length >= 4 ? str.substring(0, 4) : str;
}

/** 年份选择器绑定值：归一到当年 1 月 1 日 */
export function normalizeGraduationYearForPicker(val) {
    if (val == null || val === '') {
        return '';
    }
    const parsed = moment(val);
    return parsed.isValid() ? parsed.startOf('year').format('YYYY-MM-DD') : '';
}

/** 提交入库：保存为当年 1 月 1 日，便于与 LocalDate 兼容 */
export function toGraduationYearStorage(val) {
    if (val == null || val === '') {
        return null;
    }
    const parsed = moment(val);
    return parsed.isValid() ? parsed.startOf('year').format('YYYY-MM-DD') : null;
}
